const React = require("react");

function ArrowUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 10l7-7m0 0l7 7m-7-7v18"
  }));
}

module.exports = ArrowUpIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ArrowUpIcon.js
 ** module id = 446
 ** module chunks = 0
 **/